/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';

	const gallerySwiper = () => {
		const galleryElement = document.querySelector('.first-salon-gallery');
		if (!galleryElement) return; // 要素が存在しない場合は早期リターン

		var firstSalonGalleryElement = document.querySelector('.first-salon-gallery');
		if (firstSalonGalleryElement) {
			var firstSalonGallery = new Splide('.first-salon-gallery', {
				type: 'loop',
				perPage: 1.5,
				perMove: 1,
				autoplay: true,
				gap: '20px',
				interval: 5000,
				speed: 500,
				arrows: true,
				pagination: true,
				paginationKeyboard: true,
				focus: 'center', // 中央表示を維持
				destroy: true,
				breakpoints: {
					1024: {
						destroy: false,
					},
				},
			});
			try {
				firstSalonGallery.mount();
				console.log('firstSalonGallery initialized successfully');
			} catch (error) {
				console.error('Error initializing firstSalonGallery:', error);
			}
		}
	};

	const chart = () => {
		const startButton = document.querySelector('.js-start-chart-button');
		if (!startButton) return; // 要素が存在しない場合は早期リターン

		const block01 = document.querySelector('.start-chart-block01');
		const block02 = document.querySelector('.start-chart-block02');
		const block03 = document.querySelector('.start-chart-block03');
		const radiobtn = document.querySelectorAll('.start-chart-radio input');
		const backbtn = document.querySelectorAll('.js-start-chart-q-button');
		const Qitem = document.querySelectorAll('.start-chart-block02-in');

		// スムーズスクロール関数
		function smoothScrollToTop() {
			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			});
		}

		// 診断スタート
		startButton.addEventListener('click', function(){
			block01.classList.add('di_none');
			block02.classList.remove('di_none');
			smoothScrollToTop();
		});

		// 設問選択
		radiobtn.forEach(function(radio) {
			radio.addEventListener('change', function() {
				const name = this.getAttribute('name');
				const value = this.value;

				if(name == '2') {
					if(value == '0') {
						block02.classList.add('di_none');
						block03.classList.remove('di_none');
						document.querySelector('.start-chart-block03-3-0').classList.remove('di_none');
						setTimeout(() => {
							chartSlide();
						}, 200);
					} else if(value == '1') {
						block02.classList.add('di_none');
						block03.classList.remove('di_none');
						document.querySelector('.start-chart-block03-3-1').classList.remove('di_none');
						setTimeout(() => {
							chartSlide();
						}, 500);
					} else if(value == '2') {
						block02.classList.add('di_none');
						block03.classList.remove('di_none');
						document.querySelector('.start-chart-block03-3-2').classList.remove('di_none');
						setTimeout(() => {
							chartSlide();
						}, 200);
					} else if(value == '3') {
						block02.classList.add('di_none');
						block03.classList.remove('di_none');
						document.querySelector('.start-chart-block03-3-3').classList.remove('di_none');
						setTimeout(() => {
							chartSlide();
						}, 200);
					} else if(value == '4') {
						block02.classList.add('di_none');
						block03.classList.remove('di_none');
						document.querySelector('.start-chart-block03-3-4').classList.remove('di_none');
						setTimeout(() => {
							chartSlide();
						}, 200);
					}
				} else {
					Qitem.forEach(item => item.classList.add('di_none'));
					Qitem[Number(name) + 1].classList.remove('di_none');
				}

				// matchHeightの代替（必要に応じて実装）
				setTimeout(function(){
					// matchHeightが必要な場合は、別途実装が必要
					// ここでは省略
				}, 500);
			
				smoothScrollToTop();
			});
		});

		// ひとつ前に戻る
		backbtn.forEach(function(btn) {
			btn.addEventListener('click', function(){
				const dataName = this.getAttribute('data-name');
				Qitem.forEach(item => item.classList.add('di_none'));
				Qitem[Number(dataName) - 1].classList.remove('di_none');
				smoothScrollToTop();
			});
		});
	};

	const chartSlide = () => {
		const chartResultSlideElements = document.querySelectorAll('.mod-slider-chartResult');
		chartResultSlideElements.forEach((el) => {
			try {
				const chartResultSlide = new Splide(el, {
					type: 'loop',
					perPage: 3,
					perMove: 1,
					autoplay: false,
					gap: '24px',
					interval: 5000,
					speed: 500,
					arrows: false,
					pagination: false,
					paginationKeyboard: false,
					breakpoints: {
						1024: {
							autoplay: true,
							perPage: 1.5,
							gap: '20px',
							arrows: true,
							pagination: true,
							paginationKeyboard: true,
							focus: 'center',
						},
					},
				});
				chartResultSlide.mount();
				console.log('Splide initialized for:', el);
			} catch (error) {
				console.error('Error initializing Splide for:', el, error);
			}
		});
	};

	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	const topFUNCTIONS = () => {
		gallerySwiper();
		chart();
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { topFUNCTIONS(); }) : topFUNCTIONS();

})(window.FUNCTIONS);
